import {put} from 'redux-saga/effects';
import LoginActions from '../../reducers/login/LoginRedux';
import {UserActions} from '../../reducers/user/index';


// process STARTUP actions
export function* startup(action) {
  const token = localStorage.getItem('login_token') || null;
  let role = localStorage.getItem('role') || null;

  if (token) {
    yield put(LoginActions.createLoginSuccess({token, role}));
    yield put(UserActions.getUserRequest());
  }
}
